
  import { defineComponent, PropType } from 'vue';

  import TableComponent from '@/common/components/redesigned/Table/TableComponent.vue';
  import type { TPaginationConfig, TTableColumnConfig } from '@/common/components/redesigned/Table/types/tableTypes';
  import { TStorePaths } from '@/common/types/storePaths';
  import { getRuFormattedRangeDateWithMonthWord } from '@/common/utils/dates';

  import {
    REGION_DASHBOARDS_VES_ACTIONS_NAME,
    REGION_DASHBOARDS_VES_GETTERS_NAME,
    REGION_DASHBOARDS_VES_MUTATIONS_NAME,
  } from '../../../store/regionDashboards/name';
  import {
    TDashboardRegionRepresentativeAbroadFilter,
    TRegionDashboardRepresentativeAbroadInfoTableItem,
  } from '../../../types/regionDashboards';

  export default defineComponent({
    name: 'RegionDashboardsRepresentativeAbroadInfoTable',
    components: {
      TableComponent,
    },
    props: {
      filter: {
        type: Object as PropType<TDashboardRegionRepresentativeAbroadFilter>,
        required: true,
      },
    },
    data(): {
      columns: TTableColumnConfig<TRegionDashboardRepresentativeAbroadInfoTableItem>[];
      storePaths: TStorePaths;
      pagination: TPaginationConfig;
    } {
      return {
        columns: [
          {
            field: 'startEventDate',
            title: 'Даты',
            width: 200,
            formatter: (item) => getRuFormattedRangeDateWithMonthWord(item.startEventDate, item.endEventDate, true),
          },
          {
            field: 'description',
            title: 'Описание мероприятия',
            width: 539,
          },
          {
            field: 'contactOrg',
            title: 'Контакты организаторов',
            width: 539,
          },
        ],
        storePaths: {
          getter: REGION_DASHBOARDS_VES_GETTERS_NAME.getRepresentativeAbroadInfoTable,
          mutation: REGION_DASHBOARDS_VES_MUTATIONS_NAME.setRepresentativeAbroadInfoTable,
          action: REGION_DASHBOARDS_VES_ACTIONS_NAME.getRepresentativeAbroadInfoTable,
        },
        pagination: {
          size: 4,
        },
      };
    },
  });
